// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const GET_PROVINCES_DATA = 'GET_PROVINCES_DATA';
export const GET_PROVINCES_DATA_SUCCESS = 'GET_PROVINCES_DATA_SUCCESS';

export const { getProvincesData, getProvincesDataSuccess } = createActions(
    GET_PROVINCES_DATA,
    GET_PROVINCES_DATA_SUCCESS
);
